export const readStoredTimestamp = (storageKey: string): number | null => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) {
      return null;
    }
    const timeStamp = Number(raw);
    if (Number.isNaN(timeStamp) || timeStamp <= Date.now()) {
      localStorage.removeItem(storageKey);
      return null;
    }
    return timeStamp;
  } catch {
    return null;
  }
};

export const writeStoredTimestamp = (storageKey: string, timestamp: number) => {
  try {
    localStorage.setItem(storageKey, String(timestamp));
  } catch {
    console.error(`Failed to write stored timestamp to localStorage for key: ${storageKey}`);
  }
};

export const clearStoredTimestamp = (storageKey: string) => {
  try {
    localStorage.removeItem(storageKey);
  } catch {
    console.error(`Failed to clear stored timestamp from localStorage for key: ${storageKey}`);
  }
};
